import { render, staticRenderFns } from "./TableTags.vue?vue&type=template&id=551b4f60&"
import script from "./TableTags.vue?vue&type=script&lang=js&"
export * from "./TableTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports